export const FRAYZE_SOCIAL_LINKS = [
  "https://x.com/frayzeinccanada",
  "https://facebook.com/frayze.ca",
  "https://youtube.com/@frayzetech",
  "https://instagram.com/frayze.ca",
  "https://www.linkedin.com/company/frayze/",
  "https://ca.pinterest.com/FrayzeTech",
  "https://trustpilot.com/review/frayze.ca",
  "https://www.yelp.com/biz/frayze-technologies-thunder-bay",
  "https://www.yellowpages.ca/bus/Ontario/Thunder-Bay/Frayze-Technologies-Inc/104910990.html?what=frayze+technologies&where=Thunder+Bay+ON",
  "https://www.bbb.org/ca/on/thunder-bay/profile/computer-software/frayze-technologies-inc-0057-1000008497",
  "https://www.tiktok.com/@frayzetech",
  "https://indeed.com/cmp/Frayze-Technologies-Inc.",
  "https://maps.app.goo.gl/83g7Ew9PjxcsJQkMA",
  "https://n49.com/biz/6560392",
  "https://www.alignable.com/thunder-bay-on/frayze-technologies-inc"
];

export const FRAYZE_ADDRESS = {
  "@type": "PostalAddress",
  "streetAddress": "202 Franklin St N",
  "addressLocality": "Thunder Bay",
  "addressRegion": "ON",
  "postalCode": "P7C 4H9",
  "addressCountry": "CA"
};

export const FRAYZE_OPENING_HOURS = [
  {
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
    "opens": "09:00",
    "closes": "17:00"
  }
];

export const FRAYZE_TELEPHONE = "+1-807-700-0079";
export const FRAYZE_EMAIL = "hello@frayze.ca";

export function generateProfessionalServiceSchema(overrides = {}) {
  return {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "@id": "https://frayze.ca/#organization",
    "name": "Frayze Technologies Inc.",
    "alternateName": "Frayze",
    "url": "https://frayze.ca",
    "logo": {
      "@type": "ImageObject",
      "url": "https://frayze.ca/images/clients/frayze-business.webp"
    },
    "description": "Canada's leading digital agency specializing in CRM systems, lead generation, web development & custom AI solutions.",
    "telephone": FRAYZE_TELEPHONE,
    "email": FRAYZE_EMAIL,
    "address": FRAYZE_ADDRESS,
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 48.3808,
      "longitude": -89.2477
    },
    "foundingDate": "2025",
    "founder": [
      {
        "@type": "Person",
        "name": "Denis Mahoney"
      },
      {
        "@type": "Person",
        "name": "Parth Bhanushali"
      }
    ],
    "areaServed": [
      {
        "@type": "City",
        "name": "Thunder Bay"
      },
      {
        "@type": "AdministrativeArea",
        "name": "Northern Ontario"
      },
      {
        "@type": "Country",
        "name": "Canada"
      }
    ],
    "openingHoursSpecification": FRAYZE_OPENING_HOURS,
    "priceRange": "$$",
    "sameAs": FRAYZE_SOCIAL_LINKS,
    "taxID": "702681826RT0001",
    ...overrides
  };
}
